module.exports = __webpack_public_path__ + "img/Search_16px_Icon.264d8c0a.svg";